const Footer = () => {
    return <div className="footer">&copy; 2022 Pristine Pools</div>
}

export default Footer;